import GeoJSON from "ol/format/GeoJSON";
export function extentToOLExtent(extent) {
    //An array of numbers representing an extent: [minx, miny, maxx, maxy].
    return [extent.minx, extent.miny, extent.maxx, extent.maxy];
}
export function transformGeoJSON(geojson, srid_from, srid_to) {
    const ol_format = new GeoJSON({
        dataProjection: `EPSG:${srid_from}`,
    });
    if (geojson.type == "FeatureCollection") {
        const ol_features = ol_format.readFeatures(JSON.stringify(geojson), {
            dataProjection: `EPSG:${srid_from}`,
        });
        const geojson_transformed = ol_format.writeFeaturesObject(ol_features, {
            dataProjection: `EPSG:${srid_to}`,
            featureProjection: `EPSG:${srid_from}`,
        });
        return geojson_transformed;
    }
    else if (geojson.type == "Feature") {
        const ol_feature = ol_format.readFeature(JSON.stringify(geojson), {
            dataProjection: `EPSG:${srid_from}`,
        });
        const geojson_transformed = ol_format.writeFeatureObject(ol_feature, {
            dataProjection: `EPSG:${srid_to}`,
            featureProjection: `EPSG:${srid_from}`,
        });
        return geojson_transformed;
    }
    return geojson;
}
//# sourceMappingURL=utils.js.map